import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';

@Component({
  selector: 'app-confirm-for-prescriber',
  templateUrl: './confirm-for-prescriber.component.html',
  styleUrl: './confirm-for-prescriber.component.scss'
})
export class ConfirmForPrescriberComponent implements OnInit {
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmForPrescriberComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void { }

  closeDialog() {
    this.dialogRef.close();
  }

  allMedWaitingForPrescriber() {
    const payload = {
      request_order_id: this.data.item?.prescriber_id
    }
    this.isLoading = true;
    this.shippingService.allWaiting_for_prescriber(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.toastr.success(res?.body?.message || 'Order marked as waiting for prescriber successfully');
          this.dialogRef.close(res?.body?.success);
          this.isLoading = false;
        }
      }, error: (err) => {
        console.error('error::', err);
        this.toastr.error(err?.message || 'Failed to cancel order');
        this.dialogRef.close(false);
        this.isLoading = false;
      }
    });
  }

}
